import { render, staticRenderFns } from "./radio-defaultValue-editor.vue?vue&type=template&id=aaa406d8&scoped=true&"
import script from "./radio-defaultValue-editor.vue?vue&type=script&lang=js&"
export * from "./radio-defaultValue-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa406d8",
  null
  
)

export default component.exports